import { render, staticRenderFns } from "./CustomFieldsPreviewComponent.vue?vue&type=template&id=6c06fdd6&lang=pug"
import script from "./CustomFieldsPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsPreviewComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c06fdd6')) {
      api.createRecord('6c06fdd6', component.options)
    } else {
      api.reload('6c06fdd6', component.options)
    }
    module.hot.accept("./CustomFieldsPreviewComponent.vue?vue&type=template&id=6c06fdd6&lang=pug", function () {
      api.rerender('6c06fdd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/CustomFieldsPreview/CustomFieldsPreviewComponent.vue"
export default component.exports